export default __webpack_public_path__ + "static/media/gem-icon-yellow.7dc17902.svg";